import * as React from 'react';
import {
	ChipField,
	Datagrid,
	ImageField,
	ListProps, ReferenceArrayField,
	ReferenceField,
	SingleFieldList,
	TextField,
	UrlField
} from 'react-admin';
import './TrainingDatagrid.scss';
import { TranslateField } from '../components/TranslateField';

export const TrainingDatagrid = (props: ListProps): React.ReactElement => {
	return (
		<Datagrid rowClick="edit" className="trainings-table" optimized
		          hasBulkActions={true}
		          rowStyle={(row: any) => ({ borderRightColor: row._readAt ? '#49d18c' : '#bbbbbb' })}>
			<TextField source="id" label="#"/><ImageField source="featuredImageUrl" label="FEATURED_IMAGE"/><TextField
			source="name" label="NAME"/><TextField source="description" label="DESCRIPTION"/>
			<ReferenceField source="categoryId" reference="training-categories" label="CATEGORY">
				<TextField source="name"/>
			</ReferenceField>
			<ReferenceArrayField source="tagsIds" reference="tags" label="TAGS">
				<SingleFieldList>
					<ChipField label="TAGS" source="title"/>
				</SingleFieldList>
			</ReferenceArrayField>
			<UrlField source="videoUrl" label="YOUTUBE_LINK"/>
			<UrlField source="externalUrl" label="EXTERNAL_LINK"/>
			<TextField source="order" label="ORDER"/>
			<TranslateField source="language" label="LANGUAGE"/>
		</Datagrid>
	);
};
